import MiBracketPanel from './MiBracketPanel';
export default MiBracketPanel;